import { z } from 'zod';

import {
  MdmRequestFilterParams,
  RequestFilterParams,
} from './filterOptions.js';
import { MdmAttributeValueSchema } from './mdmAttribute.js';
import { LevelType } from './shared.js';

// TODO(ghostMdm): remove legacy `PricingItemSchemaOld` with `ff.ghostMdm.enabled`.
export const PricingItemSchemaOld = z.object({
  id: z.string(),
  hasChildren: z.boolean(),
  levelType: z.literal(LevelType.PRICING_ITEM),
  attributes: z.object({
    name: z.string().nullable().prefault(null),
    userDefinedId: z.string().nullable(),
    date: z.string(),
    priceType: z.string().nullable(),
    price: z.string().nullable(),
  }),
});

export const PricingItemSchemaMdm = z.object({
  id: z.string(),
  hasChildren: z.boolean(),
  levelType: z.literal(LevelType.PRICING_ITEM),
  attributes: z.record(z.string(), MdmAttributeValueSchema),
});

const UpdateDataSchema = z.record(z.string(), z.string().nullable());
//TODO: remove with `ff.ghostMdm.enabled`
const UpdateDataSchemaOld = z.object({
  price: z.string().nullable(),
});
export const BulkUpdateItemRequestSchema = z.object({
  virtualDspCampaignId: z.string(),
  updateData: UpdateDataSchema.or(UpdateDataSchemaOld),
  placementFoldersWithPricingItemIds: z.array(
    z.object({
      placementFolderId: z.string(),
      includePricingItemIds: z.array(z.string()).optional(),
      excludePricingItemIds: z.array(z.string()).optional(),
    }),
  ),
  selectAll: z.boolean(),
  filters: RequestFilterParams.nullable(),
});

export const BulkUpdateItemResponseSchema = z.object({
  data: z.null(),
  error: z.null(),
});

export const BulkUpdateItemRequestSchemaMdm = z.object({
  virtualDspCampaignId: z.string(),
  updateData: z.record(z.string(), MdmAttributeValueSchema.shape.value),
  placementFoldersWithPricingItemIds: z.array(
    z.object({
      placementFolderId: z.string(),
      includePricingItemIds: z.array(z.string()).optional(),
      excludePricingItemIds: z.array(z.string()).optional(),
    }),
  ),
  selectAll: z.boolean(),
  filters: MdmRequestFilterParams.nullable(),
});
